import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
  template: require("./template.html"),
  components: {
	  "sidebar-filter": () => import("../app/sidebar"),
  }
})
class BaseContainer extends Vue {
  @Prop({ required: true })
  moduleType: number;

}

export default BaseContainer;
